import { render, staticRenderFns } from "./CashierSaleSettings.vue?vue&type=template&id=81138fbe"
import script from "./CashierSaleSettings.vue?vue&type=script&lang=ts"
export * from "./CashierSaleSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81138fbe')) {
      api.createRecord('81138fbe', component.options)
    } else {
      api.reload('81138fbe', component.options)
    }
    module.hot.accept("./CashierSaleSettings.vue?vue&type=template&id=81138fbe", function () {
      api.rerender('81138fbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cashier/CashierSaleSettings.vue"
export default component.exports